import { parseOperationsDate } from './operationsDate';

/** Ein unlesbares Datum in der Adresse zeigt heute – und sagt es, statt still zu springen. */
export function HeuteInvalidDate({ raw }: { raw: unknown }) {
  if (raw === undefined || parseOperationsDate(raw, '') !== '') return null;
  return (
    <p role="status" className="text-amber-ink text-sm">
      Das Datum „{String(raw)}“ in der Adresse ist ungültig – gezeigt wird heute.
    </p>
  );
}
